export const APP: string = import.meta.env.VITE_APP || 'checkout.ui';
export const BASKET_API: string = import.meta.env.VITE_BASKET_API || 'https://api.global.test.p2g.ninja';
export const QUOTE_API: string = import.meta.env.VITE_QUOTE_API || 'https://api.global.test.p2g.ninja';

export const PAYMENT_API: string = import.meta.env.VITE_PAYMENT_API || 'https://api.global.test.p2g.ninja';
export const EDGE_API: string = import.meta.env.VITE_PUBLIC_EDGE_API || 'https://api.global.test.p2g.ninja';
export const BOOKING_API: string = import.meta.env.VITE_BOOKING_API || 'https://api.global.test.p2g.ninja';
export const ANALYTICS_EDGE_API: string =
  import.meta.env.VITE_ANALYTICS_EDGE_API || 'https://api.global.test.p2g.ninja';
export const QUERY_API: string = import.meta.env.VITE_QUERY_API || 'https://query.test.p2g.ninja';
export const WSS: string = import.meta.env.VITE_WSS || 'wss://wss.test.p2g.ninja';
export const VERSION: string = import.meta.env.VITE_VERSION || '0.0.0';
export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT || '0.0.0';
export const CONTENT_API: string = import.meta.env.VITE_CONTENT_API_ORIGIN || '';
export const LABEL_API: string = import.meta.env.VITE_LABEL_API || '';
export const GTM_ENABLED: boolean = import.meta.env.VITE_GTM_ENABLED === 'true';
export const DEBOUNCE_TIME: number = parseInt(import.meta.env.VITE_DEBOUNCE_TIME || '750', 10);
export const BASKET_VERSION: string = import.meta.env.VITE_BASKET_VERSION || 'v1';
export const LOCALES_PATH: string =
  import.meta.env.VITE_PUBLIC_LOCALES_PATH || 'https://apps.backoffice.parcel2go.com/~/.p2g/locales/';

export const AWS_EVIDENTLY_PROJECT: string = import.meta.env.VITE_AWS_EVIDENTLY_PROJECT || 'ui-checkout';

export const AWS_REGION: string = import.meta.env.VITE_AWS_REGION || 'eu-west-1';

export const AWS_ACCESS_KEY: string = import.meta.env.VITE_AWS_ACCESS_KEY_ID || '';

export const AWS_ACCESS_SECRET: string = import.meta.env.VITE_AWS_SECRET_ACCESS_KEY || '';

export const LOCAL_TENANT_OVERRIDE: string = import.meta.env.VITE_LOCAL_TENANT_OVERRIDE;

export const TranslationNamespaces = {
  CHECKOUT: 'checkout',
  QUOTE: 'quote',
  COMPLETE: 'complete',
  COUNTRY: 'country'
};

export const TRANSLATION_NAMESPACES_ARRAY = Object.values(TranslationNamespaces);

export const Form = {
  CHECKOUTID: 'p2g-workflow-form'
};

export const CountryPostcodeValidator = ['GBR', 'GB', 'GBR-HIGH', 'GBR-NIR', 'GB-HIGH', 'GB-NIR'];
